import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class StatusProcessAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'status_process';
	}

	/**
	 * list
	 *
	 * Realiza a busca da lista associativa
	 *
	 * @access public
	 * @author Jeferson Carvalho
	 * @since  01/2019
	 * @return object Promise
	 */
	public list() {
		return this._call(this.__entity + '/list', {}, 'get');
	}
}


// WEBPACK FOOTER //
// ./src/api/status_process.api.ts